import React from "react";
import { TicketsSummaryPdfDocument } from "./TicketsSummaryPdfDocument";

export async function openTicketsSummaryPdfReport({ companyInfo, filters, report }) {
  const reportTab = typeof window !== "undefined" ? window.open("", "_blank") : null;
  if (!reportTab) throw new Error("Unable to open report tab. Please allow pop-ups and try again.");

  try {
    const { Document, Page, StyleSheet, Text, View, Image, Font, pdf } = await import("@react-pdf/renderer");
    const generatedAt = new Date().toISOString();
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const logoUrl = `${origin}/light.png`;

    // Bengali-capable font so Bangla organization/customer names render in the PDF.
    Font.register({
      family: "HindSiliguri",
      fonts: [
        { src: `${origin}/fonts/HindSiliguri-Regular.ttf`, fontWeight: 400 },
        { src: `${origin}/fonts/HindSiliguri-SemiBold.ttf`, fontWeight: 600 },
        { src: `${origin}/fonts/HindSiliguri-Bold.ttf`, fontWeight: 700 },
      ],
    });
    // Bengali words must not be hyphenated mid-word.
    Font.registerHyphenationCallback((word) => [word]);

    const reportBlob = await pdf(
      <TicketsSummaryPdfDocument
        components={{ Document, Page, StyleSheet, Text, View, Image }}
        logoUrl={logoUrl}
        companyInfo={companyInfo}
        filters={filters}
        report={report}
        generatedAt={generatedAt}
      />
    ).toBlob();

    const reportUrl = URL.createObjectURL(reportBlob);
    reportTab.location.href = reportUrl;
    setTimeout(() => URL.revokeObjectURL(reportUrl), 60_000);
  } catch (error) {
    reportTab.close();
    throw error;
  }
}
